import { useEffect, useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "经典专题", to: "/specials" },
];

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setKeyword("");
  };

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            80s<span className="text-accent-500">电影</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3 py-2 font-label text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden w-64 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-1.5 md:flex"
        >
          <i className="ri-search-line text-sm text-foreground-500"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索电影或资讯"
            className="w-full bg-transparent font-label text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            aria-label="站内搜索"
          />
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 md:hidden"
          aria-label="菜单"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2"
          >
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影或资讯"
              className="w-full bg-transparent font-label text-sm outline-none placeholder:text-foreground-400"
              aria-label="站内搜索"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-md px-3 py-2.5 font-label text-sm transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}